import { icons } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { URLs } from "../../../resources/url";
export var PROPERTIES_PAGE_TITLE = "Gestión de properties";
export var PROPERTIES_PAGE_DESCRIPTION = "Configurá atributos personalizados sobre Proyectos, Planes o Coberturas — a nivel general de la categoría o de un registro puntual.";
export var PROPERTIES_CAN_CREATE = true;
export var PROPERTIES_CAN_EDIT = true;
export var PROPERTIES_CAN_DELETE = false;
export var PROPERTIES_DEFAULT_LOADING_TEXT = "Cargando...";
export var PROPERTIES_INITIAL_LOADING_TEXT = "Cargando propiedades...";
export var PROPERTIES_MUTATION_LOADING_TEXT = "Guardando...";
export var PROPERTIES_MUTATION_SUCCESS_MESSAGES = {
    create: "Property creada con éxito",
    update: "Property actualizada con éxito",
    delete: "Property eliminada con éxito",
};
export var PROPERTIES_PROJECT_ENTITY_NAME = "Project";
export var PROPERTIES_PLAN_ENTITY_NAME = "Plan";
export var PROPERTIES_COVER_TYPE_ENTITY_NAME = "CoverType";
export var PROPERTIES_CLIENT_ENTITY_NAME = "Client";
export var PROPERTY_ENTITIES = [
    {
        entityName: PROPERTIES_PROJECT_ENTITY_NAME,
        label: "Producto",
        icon: icons.Label,
        url: URLs.project,
        filterBySponsor: true,
        note: "Al seleccionarlo se despliega Producto → Plan → Tipo de cobertura. Podés crear la property en cualquiera de los 3 niveles.",
    },
];
export var PROPERTIES_CATEGORY_GROUP_LABEL = "Categoría";
export var PROPERTIES_RECORDS_GROUP_LABEL_PREFIX = "Registros de";
export var PROPERTIES_RECORDS_HINT = "Elegí una categoría para ver sus registros.";
export var PROPERTIES_RECORDS_SEARCH_PLACEHOLDER_TREE = "Buscar en el árbol...";
export var PROPERTIES_RECORDS_SEARCH_PLACEHOLDER_LIST = "Buscar registro...";
export var PROPERTIES_RECORDS_EMPTY = "Sin resultados.";
export var PROPERTIES_GLOBAL_PANEL_TITLE_PREFIX = "Todas las properties de";
export var PROPERTIES_GLOBAL_PANEL_EMPTY = "Acá vas a ver todas las properties de la categoría, con edición rápida. Seleccioná un registro a la izquierda para ver solo las suyas y agregar nuevas.";
export var PROPERTIES_GLOBAL_PANEL_NOTE = "Edición rápida inline. Para crear una property, seleccioná el registro a la izquierda.";
export var PROPERTIES_GLOBAL_FILTER_ALL_LABEL = "Todos";
export var PROPERTIES_RECORD_PANEL_TITLE_PREFIX = "Properties de";
export var PROPERTIES_RECORD_BACK_LABEL = "← Ver todas las de la categoría";
export var PROPERTIES_RECORD_EMPTY = "Este registro no tiene properties todavía. Agregá la primera abajo.";
export var PROPERTIES_NAME_PLACEHOLDER = "name";
export var PROPERTIES_VALUE_PLACEHOLDER = "value";
export var PROPERTIES_ADD_BUTTON_LABEL = "+ Agregar";
export var PROPERTIES_SAVE_BUTTON_LABEL = "Guardar cambios";
export var PROPERTIES_CANCEL_EDIT_LABEL = "Cancelar";
var ENTITY_LABELS = {
    project: "Producto",
    plan: "Plan",
    covertype: "Tipo de cobertura",
    client: "Cliente",
};
export var getEntityLabel = function (entityName) {
    var clean = entityName.trim();
    var known = ENTITY_LABELS[clean.toLowerCase()];
    if (known)
        return known;
    if (!clean)
        return clean;
    return clean.charAt(0).toUpperCase() + clean.slice(1).toLowerCase();
};
